import React, { FC } from 'react'

const BarIcon: FC<{
    className?: string
    color?: string
}> = ({ className, color = '#FF0000', ...props }) => (
    <svg
        width="4"
        height="20"
        viewBox="0 0 4 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <rect width="4" height="20" rx="2" fill={color} />
    </svg>
)

export default BarIcon
